import { render, staticRenderFns } from "./SectionOurPartner.vue?vue&type=template&id=292c3ad9&scoped=true"
import script from "./SectionOurPartner.vue?vue&type=script&lang=ts"
export * from "./SectionOurPartner.vue?vue&type=script&lang=ts"
import style0 from "./SectionOurPartner.vue?vue&type=style&index=0&id=292c3ad9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292c3ad9",
  null
  
)

export default component.exports